<mat-form-field appearance="outline" class="datetime-picker full-width" [class.has-value]="hasValue" [floatLabel]="label ? 'always' : 'auto'">
    <mat-label *ngIf="label">{{ label }}</mat-label>
    <input matInput [matDatepicker]="picker" [formControl]="control" [min]="minDate" [max]="maxDate" [placeholder]="label ? '' : placeholder" (keyup)="formatDate($event)">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
</mat-form-field>